import React from "react";
import { Checkbox } from "antd";
const AntCheckboxGroup = Checkbox.Group;
//TODO 使用symbol优化标记
const isExclusive = d => !!d.$exclusive;
const isOverall = d => !!d.$overall;
export default class CheckBoxGroup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.lastValue = props.value;
    this.state = {
      selectedAll: this.isAllChecked(props) || false
    };
  }

  isAllChecked(props) {
    const { options = [], value = [] } = props;
    if (options && options.length && options.length === value.length)
      return true;
    return false;
  }

  componentWillReceiveProps(props) {
    let selectedAll = this.isAllChecked(props);
    if (selectedAll !== this.state.selectedAll) {
      this.setState({
        selectedAll
      });
    }
  }

  onSelectAll = () => {
    const { selectedAll } = this.state;
    const { onChange, options, field } = this.props;
    if (selectedAll) {
      onChange([]);
    } else {
      onChange(options.map(d => d.value));
    }
  };
  handleChange = (keys) => {
    const {options = [], onChange} = this.props;
    let pre = this.lastValue || []
    let added = keys.reduce((p, c) => pre.includes(c) ? p : p.concat(c), []);
    let exclusiveKeys = options.reduce((p, c) => isExclusive(c) ? p.concat(c.id) : p, []);
    //最后选中排他项
    for(let k of added){
      if(exclusiveKeys.includes(k)){
        this.lastValue = [k]
        onChange(this.lastValue)
        return;
      }
    }
    
    //全选
    //排他性优先级高于全选，一般两种属性设置一种
    let overallKeys = options.reduce((p, c) => isOverall(c) ? p.concat(c.id) : p, []);
    for(let k of added){
      if(overallKeys.includes(k)){
        this.lastValue = options.map(d => d.id)
        onChange(this.lastValue)
        return;
      }
      //TODO 加强校验
      if (keys.length === options.length - 1 && overallKeys.length){
        this.lastValue = options.map(d => d.id)
        onChange(this.lastValue)
        return;
      }
    }
    //全不选
    let minus = pre.reduce((p, c) => keys.includes(c) ? p : p.concat(c), []);
    for(let k of minus){
      if(overallKeys.includes(k)){
        this.lastValue = []
        onChange(this.lastValue)
        return;
      }
    }
    //清除全选态
    //清除排他项
    this.lastValue = keys.filter(d => !overallKeys.includes(d)).filter(d => !exclusiveKeys.includes(d))
    onChange(this.lastValue)
  }
  render() {
    const { value, field, options = [], onChange, opts = {} } = this.props;
    const { readonly } = opts;
    if (readonly){
      let v = (Array.isArray(value) ? value : []).map(d => typeof d === "object" ? d.id : d)
      return options.filter(d => v.includes(d.id)).map(d => d.name).join(",")
    }
    return (
      <>
        {/*{options.length > 1 ? (
          <Checkbox
            checked={this.state.selectedAll}
            onChange={this.onSelectAll}
          >
            全部
          </Checkbox>
        ) : null}*/}

        <AntCheckboxGroup
          name={field}
          options={options.map(d => ({
            value: d.id,
            label: d.name
          }))}
          onChange={this.handleChange}
          value={value}
          {...opts}
        />
      </>
    );
  }
}
